export const AUTH_USER = Symbol("auth.user");
export const AUTH_IS_LOGGED_IN = Symbol("auth.isLoggedIn");
export const CONFIG_STORE_CURRENCY = Symbol("store_currency");
export const CONFIG_STORE_COUNTRY = Symbol("store_country");
export const PRODUCT_CONTEXT = "product";
export const CATEGORY_CONTEXT = "category";
